import { DataTableColDef, DataTableProps } from '@chronosphereio/chrono-ui';

export const DEFAULT_TABLE_PROPS: Partial<DataTableProps> = {
  autoHeight: true,
  hideFooter: true,
  pagination: false,
};

export const DEFAULT_COLUMN_PROPS: Partial<DataTableColDef> = {
  sortable: false,
  filterable: false,
  resizable: false,
  disableColumnMenu: true,
  disableReorder: true,
};
